import { useAppSelector } from '../../../../../../store/hooks';
import { getApkIdsSelector } from '../../../../store/selectors/get-apk-ids/get-apk-ids.selector';
import { getAppsFilesSelector } from '../../../../store/selectors/get-apps-files/get-apps-files.selector';
import { getHasReleasesFormError } from '../../../../store/selectors/get-has-releases-form-error/get-has-releases-form-error.selector';
import { AppReleasesFormSelectors } from './models/app-releases-form-selectors.model';

export const useGetReleasesFormSelectors = (): AppReleasesFormSelectors => {
  const apksIds = useAppSelector(getApkIdsSelector);
  const appsFiles = useAppSelector(getAppsFilesSelector);
  const hasFormError = useAppSelector(getHasReleasesFormError);
  return {
    apksIds,
    appsFiles,
    hasFormError,
  };
};
